

import { RefObject, Dispatch, SetStateAction } from "react";

import { db } from "../firebaseConnection";
import { addDoc, doc, setDoc, getDoc, collection, getDocs, query, where, limit, Timestamp, orderBy } from "firebase/firestore";

/* endpoints */
import { ENDPOINTS } from "../../routes/endpoints.js";



export async function registerLog(id: string, descricao: string) {

    try {

        await addDoc(collection(db, "ls_flow"), {id, atualizacao: new Date(), descricao: descricao});

    }
    catch(error) {
        console.error("Erro ao registrar log:", error);
    }

}



export async function checkEmailExists(email: String) {

    try {

        const response = await fetch(ENDPOINTS.firebase.checkEmail, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({email: email})
        });

        const data = await response.json();

        if(!response.ok) {
            throw new Error(data.message || "Erro ao verificar e-mail");
        }

        return data.exists;

    }
    catch (error) {
        console.error(error);
        throw error;
    }

}



export async function registerLogOffline(descricao: String) {

    try {

        const response = await fetch(ENDPOINTS.firebase.registerLog, 
        {
            method: "POST",
        
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({descricao: descricao})
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "Erro ao registrar log");
        }

        return data;

    }
    catch (error) {
        console.error(error);
        throw error;
    }

}



export async function db_basic(idClient: string) {

    try {

        const vigenciaAtual = expiryDate();

        //query clients
        const snapClient = await getDoc(doc(db, "db_client", idClient));

        if (!snapClient.exists()) {
            throw new Error("Cliente atual não encontrado");
        }

        const clientData = {idDoc: snapClient.id, ...snapClient.data()};

        //query agents
        const qAgent = query(collection(db, "db_agent"), where("id_client", "==", idClient), where("principal", "==", true), limit(1));

        const snapAgent = await getDocs(qAgent);
     
        const agentData = snapAgent.empty ? {id: null, status: 0, plano: null} : {id: snapAgent.docs[0].id, ...snapAgent.docs[0].data()};

        return {client: clientData, agent: agentData};

    } catch (error) {
        console.error("Erro em db_basic:", error);
        throw error;
    }
}


export const formatTimestamp = (periodo: any): string | null => {
    
    if (periodo == null) return null;

    // Detecta se é Timestamp do Firebase ou número puro
    const date = periodo.toDate ? periodo.toDate() : new Date(periodo);

    const formatted = date
        .toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        })
        .replace(/\//g, ".");

    return formatted;
    
};


export const expiryDate = () => {

    const v1 = new Date("2100-12-31T23:59:59Z");
    return Timestamp.fromDate(v1);

}

export const firstName = (fullName: string): string => {
    
    if (!fullName) return "";
        const parts = fullName.trim().split(" ");
    
        return parts[0];
        
}

export const statusAgentsPanel = (status: number) => {

    switch(status) {

        case 0:
            return [
                {textButton: "CRIAR AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente não foi criado"},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não criado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não criado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não criado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
            ];

        case 1:
            return [
                {textButton: "CONFIGURAR AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente não foi configurado"},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não configurado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não configurado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não configurado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
            ];

        case 2:
            return [
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Aguardando ativação"},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não ativado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não ativado", textStatus: ""},
                {textButton: "", classButton: "", viewPanel: false, textPanel: "agente não ativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
            ];

        case 3:
            return [
                {textButton: "ALTERAR AGENTE", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: "Agente Ativado (período de testes)"},
                {textButton: "VER AGENDA", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "QUERO ASSINAR", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
            ];

        case 4:
            return [
                {textButton: "ALTERAR AGENTE", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: "Agente Ativado (assinante)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 5:
            return [
                {textButton: "ALTERAR AGENTE", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente Ativado (assinante)"},
                {textButton: "VER AGENDA", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 6:
            return [
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente desativado (pedido do cliente)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 7:
            return [
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente desativado (falta pagamento)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

        case 8:
            return [
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: true, textPanel: "", textStatus: "Agente desativado (motivo interno)"},
                {textButton: "VER AGENDA", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER DETALHES", classButton: "button_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "VER PAGAMENTOS", classButton: "button2_form", viewPanel: false, textPanel: "Agente Desativado", textStatus: ""},
                {textButton: "ALTERAR", classButton: "button2_form", viewPanel: true, textPanel: "", textStatus: ""}
            ];

            default:
            return [];

    }

}


export async function agentsmanagement(id_client: string) {

    const agentsquery = query(collection(db, "db_agent"), where("id_client", "==", id_client), orderBy("data_criacao", "desc"));
    const agentsdocs = await getDocs(agentsquery);

    let qtde = 0;
    let btao = false;

    const agentes : {id: string; nome: string; telefone: string; principal: boolean; status: number; descricao_status: string, criacao: Timestamp} [] = [];

    if(agentsdocs.size === 0) {

        qtde = 0;

    } else {

        qtde = agentsdocs.size;

        agentsdocs.forEach(doc => {
            
            const dados = doc.data();

            let st = "";
            switch(dados.status) {
                case 1: st = "agente não configurado"; break;
                case 2: st = "agente não ativado"; break;
                case 3: st = "agente ativo (testes)"; break;
                case 4: st = "agente ativo (assinante)"; break;
                case 5: st = "agente bloqueado (consumo)"; break;
                case 6: st = "agente desativado (pelo cliente)"; break;
                case 7: st = "agente desativado (inadimplência)"; break;
                case 8: st = "agente desativado (interno)"; break;
            }

            agentes.push({id: doc.id, nome: dados.nome, telefone: dados.telefone, principal: dados.principal, status: dados.status, descricao_status: st, criacao: dados.data_criacao});
        
        });

        if(qtde === 1 && agentes[0].status > 3) {
            btao = true;
        }

        if(qtde > 1) {
            
            const existeAgenteTeste = agentes.some(agente => agente.status === 3 || agente.status === 1);

            if(!existeAgenteTeste) {
                btao = true;
            }

        }

    }

    return {"qtde": qtde, "botao": btao, agentes};

}


export const dateDiffDias = (data1: Date, data2: Date) => {

    const diffMs = Math.abs(data2.getTime() - data1.getTime());

    return { dias: Math.floor(diffMs / (1000 * 60 * 60 * 24)), horas: Math.floor(diffMs / (1000 * 60 * 60)) };
    
}

export const levelPassword = (senha: string) => {

        if(senha.length === 0) {
            return "";
        } else {

            let ch1 = /^(?=.*[a-z])/; /* minuscula */
            let ch2 = /(?=.*[A-Z])/; /* maiuscula */
            let ch3 = /(?=.*\d)/; /* digito */
            let ch4 = /(?=.*[@$!%*?&])/; /* caracter especial */

            let t1 = ch1.test(senha);
            let t2 = ch2.test(senha);
            let t3 = ch3.test(senha);
            let t4 = ch4.test(senha);

            let pass = t1.toString().substring(0, 1) + t2.toString().substring(0, 1) + t3.toString().substring(0, 1) + t4.toString().substring(0, 1);

            switch(pass) {
                case "ffff": return "muito fraca"; break;
                case "tfff": return "fraca"; break;
                case "ftff": return "fraca"; break;
                case "fftf": return "fraca"; break;
                case "ffft": return "fraca"; break;
                case "ttff": return "média"; break;
                case "tftf": return "média"; break;
                case "tfft": return "média"; break;
                case "fttf": return "média"; break;
                case "ftft": return "média"; break;
                case "fftt": return "média"; break;
                case "tttf": return "forte"; break;
                case "ttft": return "forte"; break;
                case "tftt": return "forte"; break;
                case "fttt": return "forte"; break;
                default: return "muito forte";
            }
        }
        
    }
    

/* ts scripts para as inputs */

export const showError = <T>(inputRef: RefObject<HTMLInputElement | HTMLTextAreaElement>, labelRef: RefObject<HTMLInputElement>, errorRef: RefObject<HTMLSpanElement>, message: string, setErrorState?: Dispatch<SetStateAction<T>>, errorValue?: T): void => {
  
    if(errorRef?.current) {
        errorRef.current.innerHTML = message;
        errorRef.current.style.height = "1.5rem";
    }

    if(inputRef?.current) {
        inputRef.current.style.backgroundColor = "yellow";
        inputRef.current.focus();
    }

    if(labelRef?.current) {
        labelRef.current.style.borderBottom = "2px solid red";
        if (inputRef.current instanceof HTMLTextAreaElement) {
            labelRef.current.style.backgroundColor = "yellow";
        }
    }

    if(setErrorState && errorValue !== undefined) {
        setErrorState(errorValue);
    }

};

export const clearError = (inputRef: RefObject<HTMLInputElement>, labelRef: RefObject<HTMLInputElement>, errorRef: RefObject<HTMLSpanElement>, errorState: string, setErrorState?: Dispatch<SetStateAction<string>>): void => {

    if(errorState !== "0") {
        if (errorRef?.current) {
            errorRef.current.innerHTML = "";
            errorRef.current.style.height = "0";
        }

        if(inputRef?.current) {
            inputRef.current.style.backgroundColor = "";
        }

        if(labelRef?.current) {
            labelRef.current.style.borderBottom = "";
            if (inputRef.current instanceof HTMLTextAreaElement) {
                labelRef.current.style.backgroundColor = "";
            }
        }

        if (setErrorState) setErrorState("0");
    }
    
};

export const formError = (errorRef: RefObject<HTMLSpanElement>, message: string, mode: boolean): void => {

    if (errorRef?.current) {
        if(mode) {
            errorRef.current.innerHTML = message;
            errorRef.current.style.height = "1.5rem";
        }
        else {
            errorRef.current.innerHTML = "";
            errorRef.current.style.height = "0";
        }
    }
 
};

export const validarCPFouCNPJ = (valor: string): boolean => {
  
    if (!valor) return false;
    const num = valor.replace(/\D/g, "");

    //cpf - 11 dígitos
    if (num.length === 11) {
        if (/^(\d)\1{10}$/.test(num)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(num[i]) * (10 - i);
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(num[9])) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(num[i]) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(num[10]);
    }

    //cnpj - 14 dígitos
    if (num.length === 14) {
        if (/^(\d)\1{13}$/.test(num)) return false;

        let tamanho = 12;
        let numeros = num.substring(0, tamanho);
        const digitos = num.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        tamanho++;
        numeros = num.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));
    }

    return false;

}

export const wait = (ms: number): Promise<void> => { return new Promise(resolve => setTimeout(resolve, ms)); };

export const isValidDate = (value: string): boolean => {

    if (!/^\d{2}\/\d{2}\/\d{2}$/.test(value)) return false;

    const [d, m, y] = value.split('/').map(Number);
    const fullYear = 2000 + y;
    const date = new Date(fullYear, m - 1, d);

    return (
        date.getFullYear() === fullYear &&
        date.getMonth() === m - 1 &&
        date.getDate() === d
    );

};

export const dateToTimestamp = (value: string): Timestamp | null => {
    
    if (!/^\d{2}\/\d{2}\/(\d{2}|\d{4})$/.test(value)) return null;

    const [d, m, y] = value.split('/').map(Number);
    const fullYear = y < 100 ? 2000 + y : y; // converte "25" → 2025
    const date = new Date(fullYear, m - 1, d);

    // garante que a data gerada é válida
    if (
        date.getFullYear() !== fullYear ||
        date.getMonth() !== m - 1 ||
        date.getDate() !== d
    ) {
        return null;
    }

    return Timestamp.fromDate(date);

};


export const direcionaPlano = (plano: string) => {

    const prefixo = plano.slice(0, 3);

    let colecao;
    let link;
    let campo;
    let historico;

    switch(prefixo) {
        case "CMD": 
            colecao = "db_medical";
            link = "/medical";
            campo = "medico";
            historico = "hs_medical";
            break;
        case "EST": 
            colecao = "db_aesthetic";
            link = "/aesthetic";
            campo = "profissional";
            historico = "hs_aesthetic";
            break;
        case "VET": 
            colecao = "db_veterinarian";
            link = "/veterinarian";
            campo = "profissional";
            historico = "hs_veterinarian";
            break;
        case "DET": 
            colecao = "db_dentist";
            link = "/dentist";
            campo = "profissional";
            historico = "hs_dentist";
            break;
    }

    return { colecao: colecao, link: link, campo: campo, historico: historico };
    
}
